import { Paper, Box, IconButton, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { BRAND_COLOR } from "../constants";
import { exportLeadsToCSV } from "../leadsCsvHelpers";
import LeadsFilterItems from "./LeadsFilterItems";

interface LeadsFilterCardProps {
  data: LeadsManagementData;
}

export default function LeadsFilterCard({ data }: LeadsFilterCardProps) {
  const { leadsForStatus, refetch } = data;

  return (
    <Paper
      variant="outlined"
      sx={{
        mt: 2.5,
        p: "20px 22px",
        borderRadius: 2,
        display: "flex",
        flexWrap: "wrap",
        gap: 2.25,
        alignItems: "flex-end",
      }}
    >
      <LeadsFilterItems data={data} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, pb: 0.5, ml: "auto" }}>
        <Tooltip title="Refresh">
          <IconButton onClick={refetch} data-tracker="926" sx={{ color: BRAND_COLOR }}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Export">
          <IconButton
            onClick={() => exportLeadsToCSV({ leads: leadsForStatus })}
            data-tracker="927"
            sx={{ color: BRAND_COLOR }}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
}
